export const testimonials = [
  {
    name: 'Simon Sparkes',
    initial: 'S',
    color: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    meta: '4 reviews · 2 weeks ago',
    review: '"I\'ve had a problem tree for a while and gave Gavin a call. Although he was on holiday, he got straight back to me. On his return home the following week he contacted me and came straight out to give an honest opinion regarding the tree..."',
    isNew: true
  },
  {
    name: 'Brett Lawson',
    initial: 'B',
    color: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
    meta: '1 review · a month ago',
    review: '"Gavin was great to deal with and his team was awesome. Very fair price for equipment required and tree size. Very prompt service and cleanup of yard was excellent. All done within 3 hours. Gavin was more than happy to leave the larger..."',
    isNew: false
  },
  {
    name: 'Paul Georgiadis',
    initial: 'P',
    color: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
    meta: '4 reviews · 2 months ago',
    review: '"I reached out to Gavin regarding the pruning of 100 olive trees and the shaping of several pine trees near our Cellar Door on Seppeltsfield Road. Additionally, we needed to remove some gum trees that were precariously positioned near our..."',
    isNew: false
  },
  {
    name: 'Joe Norris',
    initial: 'J',
    color: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
    meta: '2 reviews · a month ago',
    review: '"Gavin and his crew did a great job clearing out overgrowth in my yard. Will absolutely be using them again."',
    isNew: false
  },
  {
    name: 'Claire Bowden',
    initial: 'C',
    color: 'linear-gradient(135deg, #ec4899 0%, #db2777 100%)',
    meta: '2 reviews · 7 months ago',
    review: '"The whole process was excellent! Very friendly, professional, knowledgeable, efficient, and affordable. I had various shrubs, roses and a glory vine removed and mature trees..."',
    isNew: false
  },
  {
    name: 'Daniel Dutschke',
    initial: 'D',
    color: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
    meta: '7 reviews · 9 months ago',
    review: '"Just had Gavin and his team remove a number of palm trees at my home. They were very careful to both protect the paving and concrete and also the other plants in their path. The whole process was excellent, good team and excellent clean up. Price was very fair. No hesitation to recommend their services."',
    isNew: false
  },
  {
    name: 'Andy Q',
    initial: 'A',
    color: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
    meta: '8 reviews · a week ago',
    review: '"Gavin and his team are absolute professionals at all tree removal services. Punctual and professional 😊👍"',
    isNew: true
  },
  {
    name: 'Clive',
    initial: 'C',
    color: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
    meta: '1 review · 4 months ago',
    review: '"Very clean and professional service. Very satisfied with work done. The whole team worked hard to complete job even when it rained during the start. My yard is nice and clean now."',
    isNew: false
  },
  {
    name: 'Geoff C',
    initial: 'G',
    color: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
    meta: '1 review · 9 months ago',
    review: '"Very friendly group of blokes who work efficiently and carefully. The quote for work was very reasonable. Work was discussed and they suggested some changes as work proceeded without the price changing. Clean up was excellent. An excellent job. Would highly recommend them to anyone needing tree work done."',
    isNew: false
  },
  {
    name: 'Tanya Wilton',
    initial: 'T',
    color: 'linear-gradient(135deg, #f43f5e 0%, #e11d48 100%)',
    meta: '1 review · 8 months ago',
    review: '"Fantastic service, work done very quickly, and all the tree mess was cleaned up and taken away. Site was left very neat and tidy. It\'s as if the trees were never there. All my questions were answered before the work took place. Even my neighbour was happy with the work done. Cost was definitely affordable."',
    isNew: false
  },
  {
    name: 'Karen Gray',
    initial: 'K',
    color: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    meta: '1 review · 9 months ago',
    review: '"Very nice people to deal with, fair price, prompt service, very efficient tree removal team, provided good safe worksite with professional road safety signs and left whole area tidy clearing all trimmings, leaves and twigs from site. Happy to recommend Gavin Luke Tree and Stump Services."',
    isNew: false
  }
];
